// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"355":"adb0ac66","530":"ec3418be","740":"569a1aff"}[chunkId] + ".css";
};